// extracted by mini-css-extract-plugin
export default {"information":"Information_information__AlHEl","content":"Information_content__-ppn+","text":"Information_text__GhuPo","image":"Information_image__Q1IWZ"};